<template>
  <div>

    <v-app>

      <v-app-bar color="primary" dark app fixed clipped-left clipped-right flat dense>
        <v-btn icon class="ml-1">
          <v-icon icon>mdi-cart</v-icon>
        </v-btn>
        <!-- <v-app-bar-nav-icon v-show="!drawer_clientes" @click.stop="$store.state.drawer = !$store.state.drawer"></v-app-bar-nav-icon> -->
        <v-toolbar-title>PDV</v-toolbar-title>

        <v-progress-circular
          v-show="loading"
          indeterminate
          :size="25"
          :width="3"
          color="white"
          class="ml-4"
        ></v-progress-circular>

        <v-spacer></v-spacer>

        <v-btn text>
          Terminal: {{ configStore.configuracoes.APP_TERMINAL }}
        </v-btn>
        <v-divider vertical inset></v-divider>
        <v-btn text>
          Data: {{hoje() | dataBR}}
        </v-btn>
        <v-divider vertical inset></v-divider>
        <v-btn text>
          Usuário: {{$auth.getUser().name}}
        </v-btn>

      </v-app-bar>

      <!-- <pdv-categorias-drawer width="250"></pdv-categorias-drawer> -->
      
      <v-main class="grey lighten-4">
        
      <v-container fluid class="mb-0">
          <pdv-produtos 
            @finalizarVenda="finalizarVenda"
          ></pdv-produtos>
        </v-container>
      </v-main>
      
      <pdv-total-drawer 
        ref="pdvTotal" 
        width="250"
        @finalizarVenda="finalizarVenda"
      ></pdv-total-drawer>

    </v-app>

    <z-dialogo-sim-nao
      ref="dialogoPerguntarFinalizarVenda"
      titulo="Finalizar Venda?"
      botaoSim="Finalizar"
      botaoNao="Cancelar"
      corBotaoSim="primary"
    >
      Esta venda será finalizada. Deseja continuar?
    </z-dialogo-sim-nao>


    <FinalizacaoSimples ref="finalizacaoSimples"></FinalizacaoSimples>
    <z-debug-info></z-debug-info>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import PdvTotalDrawer from "./PdvTotalDrawer";
import PdvCategoriasDrawer from "./PdvCategoriasDrawer";
import PdvProdutos from "./PdvProdutos";
import FinalizacaoSimples from "./FinalizacaoSimples";
import zDebugInfo from "@/components/zDebugInfo";
import { usePDVStore } from '@/app/store/pinia/pdv';
import { useConfigStore } from '@/app/store/pinia/configuracoes';


const pdvStore = usePDVStore();
const configStore = useConfigStore();
const loading = ref(false);
const dialogoPerguntarFinalizarVenda = ref(null);
const finalizacaoSimples = ref(null);

function finalizarVenda() {
  if (pdvStore.pedido.produtos.length == 0) {
    return;
  }

  finalizacaoSimples.value.abrir();
}

</script>
